<div class="fr-grid-row fr-grid-row--gutters">
  <div class="fr-col-12">
    <label class="champ_title">{{ 'ACCUEIL.RENSEIGNE_MON_ETABLISSEMENT' | translate }}</label>
  </div>
  <div class="fr-col-12">
    <label class="sub_title">{{ 'ACCUEIL.LABEL_ETABLISSEMENT_OBLIGATOIRE' | translate }}</label>
  </div>
</div>
<div class="fr-grid-row fr-grid-row--gutters" >
  <div class="fr-col-12 fr-col-sm-10 fr-col-md-7 fr-col-lg-8 fr-col-xl-8" >
    <form >
      <!-- Message d'erreur lorsque le champ est vide -->
      <mat-error role="alert" *ngIf="myControl.hasError('required')">
        {{'ACCUEIL.LABEL_ETABLISSEMENT_MANQUANT_MESSAGE' | translate }}
      </mat-error>
      <mat-error role="alert" *ngIf="errorSaisie">
        {{ 'ACCUEIL.ETABLISSEMENT_ERREUR_SAISIE' | translate }}
      </mat-error>
      <mat-form-field >
        <input
          id="etablissement-input"
          type="text"
          aria-label="champ établissement"
          aria-describedby="etablissement-sous-titre"
          matInput
          [formControl]="myControl"
          [matAutocomplete]="auto"
          [matAutocompletePosition]="'below'"
          (ngModelChange)="this.inputAuto.next($event)"
          title="{{myControl.value}}"
          (change)="emptyField()"

        />
        <button
          matSuffix
          mat-icon-button
          aria-label="Effacer le champs établissement"
          *ngIf="myControl.value"
          matSuffix
          mat-icon-button
          (click)="reset()"

        >
          <img alt="" aria-label="Reinitialisation des champs" src="../../../../assets/img/fermer.svg">
        </button>

        <mat-autocomplete  #auto="matAutocomplete" (opened)="onAutocompleteScroll()">
          <mat-option *ngIf="showResultSize " disabled >{{errorOption}} {{ 'ACCUEIL.RESULTAT_WEB_SERVICE_COMMUNE' | translate }} ({{resultSize }})</mat-option>
          <mat-option
            *ngFor="let option of filteredOptions | async"
            [value]="option"
            title="{{option}}"
            (click)="selectEtab(option)"
            (onSelectionChange)="selectEtab(option)"
            attr.aria-label="{{option}}"
          >
            {{option}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </form>
  </div>
  <div class="fr-col-12 fr-col-sm-10 fr-col-md-5 fr-col-lg-4 fr-col-xl-4 resultSizeStyle" *ngIf="isLoading">
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>

</div>

<!-- Copyright 2022 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at https://angular.io/license -->

